module.exports = __webpack_public_path__ + "img/sbzficon.d246ba0b.svg";